<template>
  <div>
    <div class="card table-card expenses-list">
      <div class="list-statusbar" :class="{hidden: !showStatusbar}">
        <div v-if="displayedFilters.length" class="list-status filter-status">
          <i class="fa fa-filter"/>
          <div v-for="filter in displayedFilters" :key="filter.label" class="filter-status-item">
            <div class="filter-title">
              {{ filter.title }}:
            </div>
            <div class="filter-label">
              {{ filter.label }}
            </div>
          </div>
        </div>
        <div class="reset-btn" @click="handleClickReset">
          Сбросить все
        </div>
      </div>
      <div class="card-body center">
        <el-table
          v-loading="loading"
          :border="false"
          :data="expensesList"
          :height="tableHeight"
          element-loading-background="rgba(255, 255, 255, 0.6)"
          :empty-text="loading ? 'Обновление данных...' : 'Денежные операции не найдены'"
          header-cell-class-name="table__header-cell">
          <el-table-column
            v-for="column in formatColumns"
            :key="column.label"
            :label="column.label"
            :prop="column.prop"
            :width="column.width"
            :align="column.align || 'left'">
            <template #default="scope">
              <div v-if="column.prop">
                {{ getValue(column, scope.row[column.prop]) }}
              </div>
              <component
                :is="column.content"
                v-else
                :data="scope.row"/>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import TotalCommissionCell from './Expenses/CellTemplates/TotalCommissionCell'
import { mapActions, mapMutations, mapGetters } from 'vuex'
import { updateTableHeight } from "@/utils/helpers";

export default {
  name: 'Expenses',
  data() {
    return {
      loading: true,
      tableHeight: 'auto',
    }
  },
  computed: {
    ...mapGetters(['displayedFilters', 'listResponseId']),
    ...mapGetters({
      expensesList: 'superadministrator/expensesList'
    }),
    columns() {
      return [
        {
          label: 'Год',
          prop: 'year',
          align: 'center'
        },
        {
          label: 'Месяц',
          prop: 'month',
          align: 'center'
        },
        {
          label: `Марафон, ${this.displayedCurrencyForStats}`,
          prop: 'marathon_sum',
          align: 'center',
          moneyFormat: true
        },
        {
          label: `Комиссия, ${this.displayedCurrencyForStats}`,
          prop: 'partnerCommission',
          align: 'center',
          moneyFormat: true
        },
        {
          label: `Итого без комиссии, ${this.displayedCurrencyForStats}`,
          prop: 'sum',
          align: 'center',
          moneyFormat: true
        },
        {
          label: `Итого с комиссией, ${this.displayedCurrencyForStats}`,
          content: TotalCommissionCell,
          align: 'center'
        }
      ]
    },
    formatColumns() {
      return this.columns.filter(column => {
        if (this.currencyForStats === 'usd') {
          return column.prop !== 'marathon_sum'
        }
        return column
      })
    },
    currencyForStats() {
      return this.$route.path.split('/')
        .reverse()[0]
    },
    displayedCurrencyForStats() {
      return {
        rub: 'руб.',
        usd: '$'
      }[this.currencyForStats]
    },
    showStatusbar() {
      return !!this.displayedFilters.length
    }
  },
  watch: {
    currencyForStats(value) {
      if (['usd', 'rub'].includes(value)) this.updateExpensesList()
    },
    listResponseId(value) {
      if (!value) return
      this.reload()
    }
  },
  methods: {
    ...mapMutations(['resetAllParameters']),
    ...mapActions({
      downloadExpensesList: 'superadministrator/downloadExpensesList'
    }),
    async updateExpensesList() {
      const downloadingMethod = async id => {
        this.loading = true
        await this.downloadExpensesList({
          currency: this.currencyForStats
        })
        this.tableHeight = updateTableHeight('expenses-list')
        this.loading = id !== this.listResponseId
      }
      await downloadingMethod(this.listResponseId)
    },
    getValue(prop, rawData) {
      if (!rawData) return '-'
      if (prop.moneyFormat) {
        return parseFloat(rawData)
          .toFixed(2)
      }
      return rawData
    },
    handleClickReset() {
      this.resetAllParameters()
    },
    reload() {
      this.updateExpensesList()
    },
  },
  async beforeMount() {
    await this.updateExpensesList()
  }
}
</script>
<style>
</style>
